import axios from 'axios'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const settlementPdfDownload = (tokens: any, reqBody: any, userAccessToken: string) => {
  return axios
    .post(`${sitConfig(tokens).baseUrl}${APIEndPoints.SettlementPDFDownload}`, reqBody, {
      headers: {
        Authorization: userAccessToken,
      },
      responseType: 'blob',
    })
    .then((resp) => {
      return responseParser(resp)
    })
}

export { settlementPdfDownload }
